import { createAppTranslation } from '@fiverr-private/i18n-react';
import copies from '../copies.json';

export const { appTranslate: translate } = createAppTranslation(copies, 'black_friday_banner');
